import { connect } from 'react-redux';
import QuoteNewService from "../Component/QuoteNewService";
import {
  checkZipCode,
  getLeadById,
  getPets,
  pricingCalculator,
  updateLeads,
  getServiceOrderEnquiry,
  addServiceOrderEnquiry,
  addCallLog,
  addNewCard,
  addServiceOrder,
  updateServiceOrder,
  resetCheckZipcode,
  resetPricingCalculator,
  addNonServiceableEnquiry,
  getCallLogList,
  updateServiceOrderEnquiry,
  getCardList,
  deleteCard,
  deletePhoneNumber,
  getFieldOfficeById,
  getGeocodeAddress,
  resetGeocodeAddress,
  getCustomerDetail,
  getRepresentativeList,
  getFieldTechnicianFilter,
  validateCoupon,
  updateCallLog
} from '../../../../Action'

const mapStateToProps = (state) => {
  const {ZipcodeCheck, Lead, Pet, PricingCalc, ServiceOrderEnquiry, ServiceOrder, AddCard, UpdateCard, DeleteCard, CallLog, CardList, DeletePhoneNumber, GoogleApi, FieldTechnicianFilter, ValidateCouponCode} = state;
  return {
    ZipcodeCheck,
    Lead,
    Pet,
    PricingCalc,
    ServiceOrderEnquiry,
    ServiceOrder,
    AddCard,
    UpdateCard,
    DeleteCard,
    CallLog,
    CardList,
    DeletePhoneNumber,
    GoogleApi,
    FieldTechnicianFilter,
    ValidateCouponCode
  }
}

const actionCreators = {
  resetPricingCalculator,
  resetCheckZipcode,
  checkZipCode,
  getLeadById,
  getPets, 
  pricingCalculator,
  updateLeads,
  getServiceOrderEnquiry,
  addServiceOrderEnquiry,
  updateServiceOrderEnquiry,
  addCallLog,
  addNewCard,
  addServiceOrder,
  updateServiceOrder,
  addNonServiceableEnquiry,
  getCallLogList,
  getCardList,
  deleteCard,
  deletePhoneNumber,
  getFieldOfficeById,
  getGeocodeAddress,
  resetGeocodeAddress,
  getCustomerDetail,
  getRepresentativeList,
  getFieldTechnicianFilter,
  validateCoupon,
  updateCallLog
}
export default (connect(mapStateToProps, actionCreators)(QuoteNewService));